<template>
  <dashboard-layout>
    <template #content>
      <router-view />
    </template>
  </dashboard-layout>
</template>

<script>
export default {

  name: 'Accounts',

  components: {
    DashboardLayout: () => import('../../layouts/DashboardLayout.vue'),
  },
};
</script>

<style lang="css" scoped>
</style>
